import styles from "./custom-textfield.module.css";
import { Input, Typography } from "antd";

const { TextArea } = Input;
const { Text } = Typography;
export function CustomTextfield({
  id,
  label,
  value,
  onChange,
  placeholder,
  type,
  size = "small",
  variant = "outlined",
  prefix,
  suffix,
  allowClear,
  rows = 0,
  disabled,
  status,
  autoSize = false,
  className,
  addonBefore,
  labelColor = "#000",
  errorMessage,
  onBlur,
  ref,
  showRequired = false,
  showOptional = false,
  onPressEnter,
  showCount,
  maxLength,
}) {
  return (
    // eslint-disable-next-line react/jsx-no-useless-fragment
    <div>
      {label ? (
        <div style={{ marginBottom: 8, fontWeight: 400, color: labelColor }}>
          {label}
          {showRequired ? (
            <span style={{ color: "red" }}>*</span>
          ) : showOptional ? (
            <span  style={{ color: "#8C8C8C" }}>
              {typeof showOptional === "string" ? ` ${showOptional}` : " (Optional)"}
            </span>
          ) : null}
        </div>
      ) : null}
      {rows > 0 ? (
        <TextArea
          id={id}
          onChange={onChange}
          variant={variant}
          value={value}
          placeholder={placeholder}
          allowClear={allowClear}
          disabled={disabled}
          status={status}
          rows={rows}
          autoSize={autoSize}
          showCount={showCount}
          maxLength={maxLength}
        />
      ) : (
        <Input
          id={id}
          onChange={onChange}
          type={type}
          variant={variant}
          value={value}
          placeholder={placeholder}
          prefix={prefix}
          ref={ref}
          suffix={suffix}
          size={size}
          addonBefore={addonBefore}
          allowClear={allowClear}
          disabled={disabled}
          status={status}
          className={className}
          onBlur={onBlur}
          onPressEnter={onPressEnter}
          onWheel={(e) => e.target.blur()}
        />
      )}
      <Text type="danger" style={{ marginTop: 5 }}>
        {errorMessage}
      </Text>
    </div>
  );
}

export default CustomTextfield;
